import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useTranslation } from "react-i18next";

import "./Wizardsession.css";
import {
  addwizardexercise,
  getsubtypedefault,
} from "../../components/funtionsBD/Mainservice";
import Wizard2 from "./Wizardsetup2";
import { currentAppLanguage } from "../../utils/appLanguages";

const Wizardsession = () => {
  const [list, setlist] = useState();
  const [w2, setw2] = useState(false);
  const [cbnum, setcbnum] = useState(0);
  const [cbmin, setcbmin] = useState(0);
  const [selectedcblist, setselectedcblist] = useState([]);
  const [open, setopen] = useState(false);
  const [success, setsuccess] = useState();
  const [error, seterror] = useState();
  const currentlng = currentAppLanguage();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const min = location.state.min;

  useEffect(() => {
    typelist();
  }, []);

  useEffect(() => {
    if (cbnum === 0) {
      setcbmin(0);
    }
  }, [cbnum]);
  console.log(cbmin);
  const typelist = async () => {
    try {
      const response = await getsubtypedefault();
      const data = response.data.data.map((d) => ({
        ...d,
        steps: 0,
        duration: 0,
      }));
      setlist(data);
    } catch (error) {
      console.log(error);
    }
  };
  const handlecbnumber = (e) => {
    const newNum = parseInt(e.target.value);
    const currentTotal = calculateTotalTime(list);

    const totalWithNewValue =
      currentTotal - parseInt(cbmin * cbnum || 0) + cbmin * newNum;

    if (!totalWithNewValue || totalWithNewValue <= min) {
      setcbnum(parseInt(e.target.value));
      setselectedcblist([]);
    }
  };

  const handlenumchange = (e, i) => {
    const newNum = parseInt(e.target.value);
    const currentTotal = calculateTotalTime(list);
    const totalWithNewValue =
      currentTotal - parseInt(i.duration * i.steps || 0) + i.duration * newNum;

    if (!totalWithNewValue || totalWithNewValue <= min) {
      if (newNum === 0) {
        const updatenum = list.map((prev) =>
          prev.sub_type_id === i.sub_type_id
            ? { ...prev, steps: e.target.value, duration: 0 }
            : prev
        );
        setlist(updatenum);
      } else {
        const updatenum = list.map((prev) =>
          prev.sub_type_id === i.sub_type_id
            ? { ...prev, steps: e.target.value }
            : prev
        );
        setlist(updatenum);
      }
    } else {
      alert(`${t("timeexceed")} ${min}${t("minute")}.`);
    }
  };
  const calculateTotalTime = (list) => {
    const num = isNaN(parseInt(cbnum)) ? 0 : parseInt(cbnum);
    const min = isNaN(parseInt(cbmin)) ? 0 : parseInt(cbmin);

    const cb = num * min;
    const time = list?.reduce(
      (acc, curr) => acc + parseInt(curr.duration * curr.steps || 0),
      0
    );
    return time + cb;
  };

  const handlecbmin = (e) => {
    const newMin = parseInt(e.target.value);

    const currentTotal = calculateTotalTime(list);
    const totalWithNewValue = currentTotal - parseInt(cbmin || 0) + newMin;

    if (!totalWithNewValue || totalWithNewValue <= min) {
      if (selectedcblist.length > 0 && cbmin === 0) {
        setcbmin(1);
      } else {
        setcbmin(e.target.value);
        setselectedcblist(
          selectedcblist.map((d) => ({
            ...d,
            duration: e.target.value,
          }))
        );
      }
    } else {
      alert(`${t("timeexceed")} ${min}${t("minute")}.`);
    }
  };
  const handleminchange = (e, i) => {
    const newMin = parseInt(e.target.value);
    const currentTotal = calculateTotalTime(list);

    const totalWithNewValue = currentTotal - parseInt(i.duration || 0) + newMin;

    if (!totalWithNewValue || totalWithNewValue <= min) {
      const updatedList = list.map((item) =>
        item.sub_type_id === i.sub_type_id
          ? { ...item, duration: newMin }
          : item
      );
      setlist(updatedList);
    } else {
      alert(`${t("timeexceed")} ${min}${t("minute")}.`);
    }
  };

  const handleadd = (list, num) => {
    setselectedcblist(list);
  };

  const wizardsubmit = async () => {
    try {
      // Validate that type exists and has te_gen_mode_id
      if (!location.state?.type || !location.state.type.te_gen_mode_id) {
        console.error("⚠️ Wizardsession - Cannot submit: type or te_gen_mode_id is missing");
        seterror(t("trainingModeNotDefined") || "Training mode is not defined. Please contact an administrator.");
        return;
      }

      if (
        cbmin !== 0 &&
        selectedcblist?.reduce(
          (acc, curr) => acc + parseInt(curr.steps || 0),
          0
        ) === cbnum
      ) {
        const cbid = selectedcblist.map(({ cb_id, steps, duration }) => ({
          cb_id,
          steps,
          duration,
        }));
        const selectex = list.filter((l) => l.steps > 0);
        const exid = selectex.map(
          ({ def_ex_id: { ex_id }, steps, duration }) => ({
            ex_id,
            steps,
            duration,
          })
        );

        const params = {
          ts_duration: min,
          ts_type_id: location.state.type.te_gen_mode_id,
          ts_date: moment(location.state.date).format("DD/MM/YYYY"),
          ts_start_time: location.state.time,
          gr_id: location.state.grpid,
          cb_ids: cbid,
          ex_ids: exid,
        };
        const response = await addwizardexercise(params);
        setsuccess(response.data.message);
        setopen(true);
        setTimeout(() => {
          navigate("/home");
        }, 1000);
      } else {
        seterror(`${t("choosecb")}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div id="adminRoot">
        <h1 className="wizard_title">
          {t("wizard")} -{">"}
        </h1>
        <p className="wizard_time">
          {t("duration")}: {min} {t("min")}
        </p>
        <div className="wizard_card">
          <div className="wizard_info">
            <p>{t("competencyblock")}</p>

            <div className="Wizard_CB">
              {selectedcblist &&
                selectedcblist.map((list) => (
                  <p className="Wizard_cb_info">
                    {list[`cb_name_${currentlng}`]} x {list.steps}
                  </p>
                ))}

              <p
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setw2(true);
                  seterror();
                }}
              >
                {cbnum > 0 && cbmin > 0
                  ? `+${
                      cbnum -
                      selectedcblist?.reduce(
                        (acc, curr) => acc + parseInt(curr.steps || 0),
                        0
                      )
                    }`
                  : ""}
              </p>
            </div>
          </div>
          <div className="Wizard_editdiv">
            <div className="wizard_edittime">
              <input type="number" value={cbmin} onChange={handlecbmin} />
              <p>{t("minute")}</p>
            </div>
            <div className="wizard_edittime">
              <input
                type="number"
                value={cbnum}
                min={0}
                onChange={handlecbnumber}
              />
              <p>{t("Numofex")}</p>
            </div>
          </div>
        </div>

        {list?.map((i, index) => (
          <div className="wizard_card" key={index}>
            <div className="wizard_info">
              <p>{i[`sub_type_name_${currentlng}`]}</p>
            </div>
            <div className="Wizard_editdiv">
              <div className="wizard_edittime">
                <input
                  type="number"
                  value={i.duration}
                  onChange={(e) => handleminchange(e, i)}
                />
                <p>{t("minute")}</p>
              </div>
              <div className="wizard_edittime">
                <input
                  type="number"
                  value={i.steps}
                  min={0}
                  max={1}
                  onInput={(e) => {
                    if (e.target.value > 1) {
                      e.target.value = 1;
                    }
                  }}
                  onChange={(e) => handlenumchange(e, i)}
                />
                <p>{t("Numofex")}</p>
              </div>
            </div>
          </div>
        ))}
        {error && <p className="invalid">{error}</p>}
        <Wizard2
          open={w2}
          setopen={setw2}
          handleadd={handleadd}
          cbnum={cbnum}
          cbmin={cbmin}
        />
        <div className="input-detail">
          <button className="w-100" onClick={wizardsubmit}>
            {t("generate")}
          </button>
        </div>
        <Snackbar
          open={open}
          autoHideDuration={4000}
          onClose={() => setopen(false)}
        >
          <Alert variant="filled" severity="success">
            {success}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
};
export default Wizardsession;
